import React, { useEffect, useState } from 'react';
import { Button, Offcanvas } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { useLocation } from 'react-router-dom';
import {
  useCreateAiAnalysisMutation,
  useLazyGetKeywordsProgressChartQuery
} from '@/app/KeywordTracker/api/keywordsApi';
import { getColor } from '@/helpers/utils';
import { hideDrawer } from '@/app/common/reducers/drawer';
import timeStampToDate from '@/helpers/timeStampToDate';
import DrawerWrapper from '@/app/common/components/DrawerWrapper';
import CardSkeleton from '@/app/common/components/skeleton/CardSkeleton';
import LineTimeChart from '@/app/common/components/LineTimeChart';

const KeywordProgressDrawer = () => {
  const [chartData, setChartData] = useState(null);
  const { data: userInfo } = useGetUserInfoQuery();
  const dispatch = useDispatch();

  const { key, payload } = useSelector(state => state.drawer);
  const { keyword_id, keyword, nodeData } = payload ?? '';
  const [getData] = useLazyGetKeywordsProgressChartQuery();
  useEffect(() => {
    if (keyword && keyword_id && key === 'keyword_progress') {
      getData({
        keyword_id,
        keyword: decodeURIComponent(keyword)
      })
        .unwrap()
        .then(res => {
          setChartData(res);
        });
    }

    return () => {
      setChartData(null);
    };
  }, [keyword_id, keyword]);
  const [createAiAnalysis] = useCreateAiAnalysisMutation();
  return (
    <DrawerWrapper
      show={key === 'keyword_progress'}
      title={
        <div className="d-flex flex-wrap gap-3 align-items-center">
          <h6 className="m-0 fw-light">
            نمودار روند رتبه در کلمه&nbsp;
            <span className="fw-bolder">
              ( {keyword ? decodeURIComponent(keyword) : ''} )
            </span>
          </h6>
        </div>
      }
    >
      {chartData ? (
        <LineTimeChart
          isInversed={true}
          topLabel="روند رتبه"
          isFullDate
          dates={
            chartData?.data?.update_dates
              ? chartData?.data?.update_dates
              : // ?.map(item =>
                //     timeStampToDate(item)?.slice(8)
                //   )
                []
          }
          series={
            chartData
              ? [
                  {
                    name: 'روند رتبه',
                    data: chartData?.data?.ranks,
                    color: getColor('primary')
                  }
                ]
              : []
          }
        />
      ) : (
        <CardSkeleton />
      )}
    </DrawerWrapper>
  );
};

export default KeywordProgressDrawer;
